<template>
  <div class="config_main_manage_background preferences-page">
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item class="left_item" @click.native="$router.replace('/ConfigMainPage')">
          <img slot="topnavimg" class="main_top_img" src="~assets/img/topnav/zuofanhui.png" alt="" />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item><div slot="topimgtext">偏好管理</div></top-nav-item>
        <top-nav-item class="right_item" @click.native="goControl">
          <img slot="topnavimg" class="main_top_img" src="~assets/img/topnav/shebei_home.png" alt="首页" />
        </top-nav-item>
      </top-nav>
    </div>
    <div class="config_main_manage_page_wraper">
      <config-hang :switch-state="visible ? 1 : 0" role="switch" :aria-checked="String(visible)"
        aria-label="显示Ai助理" aria-describedby="ai-entry-description" tabindex="0"
        @click.native="toggle" @keydown.space.native.prevent="toggle" @keydown.enter.native.prevent="toggle">
        <span slot="config_hang_ele2_1">显示Ai助理</span>
        <span slot="config_hang_ele2_2" id="ai-entry-description">打开后将在控制页面显示Ai助理入口</span>
        <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt="" />
        <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt="" />
      </config-hang>
    </div>
  </div>
</template>
<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configHang from 'components/common/config/config-hang'
import { entryVisible, setEntryVisible, returnPath } from '@/ai/state/preferences'
// 暂不提供菜单入口，保留页面作为设置样式参考。
// 后续增加其他设置行时参考 Ai助理设置（AiSettings.vue）的样式，增加后本页 Ai助理设置行可直接删除。
// 与设置管理共用导航外层、配置行及开关资源；账号偏好存储仍由偏好模块负责。
export default {
  components: { topNav, topNavItem, configHang },
  data: () => ({ visible: entryVisible() }),
  activated() { this.visible = entryVisible() },
  methods: {
    toggle() { this.visible = !this.visible; setEntryVisible(this.visible) },
    goControl() { this.$router.replace(returnPath(this.$store.state.publicinfo.configReturnPath)) }
  }
}
</script>
<style scoped>
.preferences-page { display:flex;flex-direction:column;min-height:0; }
.preferences-page > .config_main_manage_topnav { flex:none; }
.preferences-page > .config_main_manage_page_wraper { flex:1;min-height:0;height:auto;width:100%; }
.preferences-page .config_hang_wraper:focus-visible { outline:2px solid var(--primary-color);outline-offset:-2px; }
</style>
